export const PLINKO_BALL_COLORS = { low: '#62d7f5', medium: '#a3e600', high: '#d878ee', expert: '#ffbd00' };
export const PLINKO_RISK_PALETTES = {
  low: ['#008de4', '#29a9ef', '#66c9ed', '#a0ebe7'],
  medium: ['#16b500', '#3fca00', '#80dc00', '#b6ed00'],
  high: ['#a242e8', '#b766eb', '#d182ed', '#eda7f2'],
  expert: ['#fa5f00', '#ff8300', '#ffa900', '#ffda00'],
};

// A spatial fade keeps the centre darkest without changing any payout values.
// Higher risks keep their central low-return band dark, as in the reference.
export const plinkoBucketColor = (risk, bucket, rows) => {
  const centre = rows / 2;
  const core = ['high', 'expert'].includes(risk) ? Math.floor(rows / 8) : (rows % 2) / 2;
  const progress = Math.max(0, Math.min(1, (Math.abs(bucket - centre) - core) / (centre - core)));
  const palette = PLINKO_RISK_PALETTES[risk];
  const position = progress * (palette.length - 1), index = Math.min(palette.length - 2, Math.floor(position));
  const blend = position - index;
  return '#' + [1, 3, 5].map((offset) => {
    const start = parseInt(palette[index].slice(offset, offset + 2), 16);
    const end = parseInt(palette[index + 1].slice(offset, offset + 2), 16);
    return Math.round(start + (end - start) * blend).toString(16).padStart(2, '0');
  }).join('');
};